// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"347":"2491a6d3","549":"25167dea"}[chunkId] + ".chunk.css";
};